import React, {useEffect, useRef} from 'react';
import FormInput from "../../formComponents/FormInput";
import FormBlock from "../../formComponents/FormBlock";
import BaseSimpleItemEditorForm from "../BaseSimplePage/BaseSimpleItemEditorForm";

const VisitTypesItemForm = ({initData, controlRef}) => {

    const controlRefName = useRef(null);

    useEffect(() => {
        if (controlRef) {
            controlRef.current = {
                validate: validate,
                getData: getData,
            };
        }
    });

    function validate() {
        let isValid = true;

        if (!controlRefName.current.validateNotEmpty("Нужно указать название!"))
            isValid = false;

        if (!controlRefName.current.validateLength(255))
            isValid = false;

        return isValid;
    }

    function getData() {
        return {
            name: controlRefName.current.getText(),
        }
    }

    return (
        <BaseSimpleItemEditorForm>
            <FormBlock title="Основные">
                <FormInput
                    controlRef={controlRefName}
                    label="Название"
                    widthLimit={350}
                    initValue={initData?.name ?? ""}
                />
            </FormBlock>
        </BaseSimpleItemEditorForm>
    );
};

export default VisitTypesItemForm;